import React from "react";

import DataGrid, {
  Editing,
  Selection,
  FilterRow,
  Pager,
  Paging,
  Column,
} from "devextreme-react/data-grid";
import { axios } from "../../../common";

export default function HomeSettingTable({ dataSource = [] }) {
  const [columns, setColumns] = React.useState([]);

  React.useEffect(() => {
    const fetchColumn = async () => {
      const { data } = await axios.get("ScreenSetting", {
        params: {
          $filter: "ScreenCode eq 'P0060'",
        },
      });
      setColumns(data.value);
    };
    fetchColumn();
  }, []);
  return (
    <>
      <DataGrid
        dataSource={dataSource}
        height={document.documentElement.offsetHeight - 189}
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnResizingMode="widget"
        alignment="center"
        allowColumnReordering={true}
        allowColumnResizing={true}
        columnHidingEnabled={true}
      >
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />

        <Editing
          mode="batch"
          allowAdding={true}
          allowDeleting={true}
          allowUpdating={true}
        />

        {columns?.map((column) => {
          const { DataField, Caption, DataType, VisibleIndex, Visible } =
            column;
          return (
            <Column
              key={DataField}
              dataField={DataField}
              caption={Caption}
              dataType={DataType}
              index={VisibleIndex}
              visible={Visible}
            />
          );
        })}
      </DataGrid>
    </>
  );
}
